import React, { createContext, useState } from 'react';

type DateType = {
  startDate: string;
  endDate: string;
  isDateDefault: boolean;
}

type PropsDateContext = {
  stateDate: DateType;
  setStateDate: React.Dispatch<React.SetStateAction<DateType>>;
}


const startDate = ''
const endDate = ''

const DEFAULT_VALUE = {
  stateDate: {
    startDate,
    endDate,
    isDateDefault: true,
  },
  setStateDate: () => {}
}


export interface TotalDateProps {
  id: number
  sd: string
  ed: string
}


const DateContext = createContext<PropsDateContext>(DEFAULT_VALUE);

const DateContextContextProvider = ({ children }: any) => {
  const [stateDate, setStateDate] = useState(DEFAULT_VALUE.stateDate)

  return (
    <DateContext.Provider value={{
      stateDate,
      setStateDate,
      }}>
      {children}
    </DateContext.Provider>
  )
}

export { DateContextContextProvider };
export default DateContext